"use client";
import { usePathname } from "next/navigation";
import Link from "next/link";

const BreadcrumbPost = () => {
  const pathname = usePathname() || ""; // Ensure it's always a string
  const pathSegments = pathname.split("/").filter((segment) => segment);

  // Capitalize function for segment names
  const formatSegment = (segment) => {
    return decodeURIComponent(segment)
      .replace(/-/g, " ") // Convert dashes to spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize words
  };


  return (
    <div className="container mx-auto py-4 breadcrumb">
      <nav
        className="flex items-center flex-wrap space-x-2 text-sm text-gray-600"
        aria-label="Breadcrumb"
      >
        <Link href="/" className="text-blue-500 hover:underline">
          Home
        </Link>
        {pathSegments.length > 0 &&
          pathSegments.map((segment, index) => {
            console.log("🚀 ~ BreadcrumbPost ~ segment:", segment);
            console.log("🚀 ~ BreadcrumbPost ~ pathSegments:", pathSegments);
            let href = "/" + pathSegments.slice(0, index + 1).join("/");
            
            let isLast = index === pathSegments.length - 1;

            if(href === "/" || href === "/pooper-scooper/category") {
              return null; // Skip the root path
            }
            if(index===1){
              href = "/" + pathSegments.slice(0, index + 1).join("/");
            }

            return (
              <div key={href}  className={`flex  items-center space-x-2 ${segment}`}>
                <span className="text-gray-400">/</span>
                {isLast ? (
                  <span className="text-gray-700">{formatSegment(segment)}</span>
                ) : (
                  <Link href={href} className="text-blue-500 hover:underline">
                    {formatSegment(segment)}
                  </Link>
                )}
              </div>
            );
          })}
      </nav>
    </div>
  );
};

export default BreadcrumbPost;
